import classnames from 'classnames';
import authHelpers from '../authorizationHelpers/index.js';
/**
 * Will try to find globally available value in DOM:
 * 	First it will try to find a global variable with passed variable name
 *  when nothing will be found it will try to find data attribute on all dom elements
 *  when nothng will be found it will return undefined
 *
 * @param nameOfGlobalVariableOrDataAttribute
 * @return value or undefined
 */
export function findValueOf(nameOfGlobalVariableOrDataAttribute) {
    const globalVariableValue = __findGlobalVariableValue(nameOfGlobalVariableOrDataAttribute);
    if (globalVariableValue != null) {
        return globalVariableValue;
    }
    let dataAttribute = nameOfGlobalVariableOrDataAttribute.indexOf('data-') > -1 ? nameOfGlobalVariableOrDataAttribute : ('data-' + nameOfGlobalVariableOrDataAttribute);
    dataAttribute = dataAttribute.split('.').join('-');
    const dataAttributeValue = __findDataAttributeValueOnDomElement(dataAttribute);
    if (dataAttributeValue != null) {
        return dataAttributeValue;
    }
    return undefined; // default when nothing is found!
    /**
     * @param dataAttribute with or without data- prefix
     * @return found value or undefined
     */
    function __findDataAttributeValueOnDomElement(dataAttribute) {
        const domElements = document.querySelectorAll('*[' + dataAttribute + ']');
        let dataAttributeValue = undefined;
        domElements && domElements.forEach(element => {
            if (dataAttributeValue === undefined) {
                dataAttributeValue = __setCorrectType(element.getAttribute(dataAttribute));
            }
            else if (dataAttributeValue !== element.getAttribute(dataAttribute)) {
                throw new Error(`Found ${domElements.length} dom elements with data attribute "${dataAttribute}", but their values do not match!`);
            }
        });
        return dataAttributeValue;
    }
    /**
     * @param dataAttribute with or without data- prefix
     * @return found value or undefined
     */
    function __findGlobalVariableValue(variableName) {
        let temp = undefined;
        variableName.split('.').forEach((item, index) => {
            if (!(index > 0 && temp == null)) {
                temp = index === 0 ? window[item] : temp[item];
            }
        });
        return temp;
    }
    function __setCorrectType(s) {
        if (s == null) {
            return s;
        }
        else if (isJsonOrArray(s)) {
            return JSON.parse(s);
        }
        else if (isFunction(s)) {
            return eval('(' + s + ')');
        }
        else if (isNumber(s)) {
            return Number(s);
        }
        return s;
    }
}
function isNumber(s) {
    return Number.isNaN(Number(s)) === false;
}
function isFunction(s) {
    return s.length > 0 && (s.indexOf('=>') > -1 || s.indexOf('function') > -1);
}
function isJsonOrArray(s) {
    return s.length > 0 && (['{', '['].includes(s[0])) && (['}', ']'].includes(s[s.length - 1]));
}
export function isMobileDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    if (/MacIntel/.test(navigator.platform)) {
        if (navigator.maxTouchPoints > 2) {
            return true;
        }
    }
    return false;
}
export function isDesktop() {
    return !isMobileDevice();
}
export function canDeviceHover() {
    return window.matchMedia('(hover:hover) and (pointer: fine)').matches;
}
export function mergeClassNames(...args) {
    let result = classnames(args).replace(/ +(?= )/g, '').trim();
    if (typeof result === 'string') {
        result = [...new Set(result.split(' '))].join(' ');
    }
    return result === '' ? undefined : result;
}
export function triggerResize() {
    const e = new Event('resize');
    window.dispatchEvent(e);
    e.preventDefault();
}
export const domStatus = (function () {
    let _loadingElementId = null;
    let _pending = {};
    let _callbacksOnReady = [];
    function tryNotifyIsReady() {
        if (_loadingElementId == null) {
            throw new Error('Before you use domStatus notifier, you have to set loading element id!');
        }
        if (Object.keys(_pending).length === 0) {
            _callbacksOnReady.splice(0).forEach(cb => cb());
            _callbacksOnReady = [];
            const loading = document.getElementById(_loadingElementId);
            if (loading) {
                loading.classList.remove('nui_app_not_ready');
                loading.style.display = 'none';
            }
        }
    }
    return {
        setLoadingElementId: (id) => {
            _loadingElementId = id;
        },
        addPendingTask: (name) => {
            _pending[name] = name;
            if (_loadingElementId == null) {
                throw new Error('Before you use domStatus notifier, you have to set loading element id!');
            }
            const loading = document.getElementById(_loadingElementId);
            if (loading) {
                loading.classList.add('nui_app_not_ready');
                loading.style.display = '';
            }
        },
        removePendingTask(name) {
            delete _pending[name];
            setTimeout(tryNotifyIsReady, 0);
        },
        isLoading: () => {
            return Object.keys(_pending).length !== 0;
        },
        notifyWhenReady: (callback) => {
            _callbacksOnReady.push(callback);
        }
    };
})();
export function getBody() {
    const el = document.body;
    if (el == null) {
        throw new Error('Body not found');
    }
    return el;
}
export function disableScrollBody(disabledBody) {
    const body = document.body;
    if (disabledBody) {
        body.style.overflow = 'hidden';
    }
    else {
        body.style.overflow = '';
    }
}
export const isDisabled = (isDisabled, requiredRoles, userRoles) => {
    return isDisabled === true ? true : !authHelpers.isAuthorized(requiredRoles, userRoles);
};
export function removeMountElement(gameName, mountKeys, deleteMountKey) {
    const mountElement = document.querySelectorAll(`.${deleteMountKey},#${deleteMountKey}`).item(0);
    const parent = mountElement === null || mountElement === void 0 ? void 0 : mountElement.parentNode;
    const elementsToDelete = [mountElement, ...getAllMountScripts(mountElement, parent, deleteMountKey)];
    parent && elementsToDelete.forEach(el => parent.removeChild(el));
    setMountsAsRegistered(mountKeys, gameName);
}
function getAllMountScripts(element, parent, mountKey) {
    const children = parent ? Array.from(parent.children) : [];
    return children.filter(child => child !== element && child.getAttribute('data-for-mount-key') === mountKey);
}
function setMountsAsRegistered(mountKeys, gameName) {
    const value = getNumberOfGameMountsInTheDOM(mountKeys);
    const _window = getWindowWithMountedInfo();
    if (_window.jamStarterGameAndNumberOfMountedElements) {
        _window.jamStarterGameAndNumberOfMountedElements[gameName] = value;
    }
    else {
        _window.jamStarterGameAndNumberOfMountedElements = { [gameName]: value };
    }
}
function getNumberOfGameMountsInTheDOM(mountKeys) {
    let numberOfMounts = 0;
    Object.values(mountKeys !== null && mountKeys !== void 0 ? mountKeys : []).forEach(mountValue => {
        numberOfMounts += document.querySelectorAll(`.${mountValue},#${mountValue}`).length;
    });
    return numberOfMounts;
}
function getWindowWithMountedInfo() {
    return window;
}
export function isElementScrollable(id) {
    const element = document.getElementById(id);
    if (!element) {
        return { horizontal: false, vertical: false };
    }
    return {
        horizontal: element.scrollWidth > element.clientWidth,
        vertical: element.scrollHeight > element.clientHeight
    };
}
/**
 * A utility class for managing hierarchical heading levels in HTML documents.
 * Ensures proper heading structure by tracking the current heading level and
 * providing methods to reset and increment heading levels appropriately.
 */
export class HeadingCounter {
    /**
     * Creates a new HeadingCounter instance.
     * @param initialHeading - The initial heading level to start with (h1-h6)
     */
    constructor(initialHeading) {
        this._currentLevel = 6;
        this.reset(initialHeading);
    }
    /**
     * Resets the current heading level to the specified tag.
     * Can only reset to a higher or equal level (e.g., from h3 to h1 or h2, but not to h4).
     * @param tag - The heading tag to reset to (h1-h6)
     * @throws {Error} When the tag is invalid or attempting to reset to a lower level
     */
    reset(tag) {
        if (!/h[1-6]/.test(tag)) {
            throw new Error(`Invalid heading: ${tag}`);
        }
        const targetLevel = parseInt(tag.charAt(1));
        if (targetLevel > this._currentLevel) {
            throw new Error(`Cannot reset heading to lower level h${targetLevel} from higher level h${this._currentLevel}`);
        }
        this._currentLevel = targetLevel;
    }
    /**
     * Returns the current heading level without descending a level.
     * @returns The current heading tag
     */
    current() {
        return `h${this._currentLevel}`;
    }
    /**
     * Ascends to the previous heading level without returning a value.
     * The level will not go below h1 (level 1).
     */
    ascend() {
        this._currentLevel = Math.max(1, this._currentLevel - 1);
    }
    /**
     * Descends to the next heading level without returning a value.
     * The level will not exceed h6 (level 6).
     */
    descend() {
        this._currentLevel = Math.min(6, this._currentLevel + 1);
    }
    /**
     * Returns the current heading level and descends to the next level.
     * The level will not exceed h6 (level 6).
     * @returns The current heading tag before descending
     */
    currentAndDescend() {
        const heading = this.current();
        this.descend();
        return heading;
    }
}
